import { AnyAction } from 'redux'

export interface IFollowerState {
  followedUrls: string[]
}

export const initialState: IFollowerState = {
  followedUrls: [],
}

export const ADD_FOLLOW_URL = 'ADD_FOLLOW_URL'

export function addUrlToFollow(url: string) {
  return {
    type: ADD_FOLLOW_URL,
    url,
  }
}

export function followerReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case ADD_FOLLOW_URL:
      return {
        followedUrls: [action.url, ...state.followedUrls.slice(0, 10)], // Max 10
      }
    default:
      return state
  }
}
